import { CancelFromInceptionConst, formatNumberWithComma, getPayeeNotPOData, Panel, PayoutChecker, PayoutPopup, PulseOpsFormat, sharedStyle, TableField, TaskDetail, TaskDetailApi, Title } from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { PayoutMethod } from './common/PayoutMethod'
import { FieldDescription, FieldText, SectionCol, SectionContent, SectionRow } from '@pulseops/submission/common'
import { pipe } from 'fp-ts/lib/function'
import * as O from 'fp-ts/Option'

type CancelRiderFromInceptionProps = {
  VERDetailData: TaskDetail.VERCancelRiderFromInception
}
export const CancelRiderFromInception = (props: CancelRiderFromInceptionProps) => {
  const { t, i18n } = useTranslation()
  const {
    lifeAssureds,
    riderNameList,
    cashOutList,
    branchName,
    methods,
    totalPayoutAmount,
    riderRefundAmount,
    // suspensePremium,
    refundableFeeAmount,
    netAmountAvailable,
    reason
  } = props.VERDetailData
  const columns = [
    {
      key: '1',
      title: t('CancelRiderFromInception:RiderName'),
      name: 'productionName'
    },
    {
      key: '2',
      title: t('requestInfo:RiskCommencementDate'),
      name: 'riskCommDate'
    },
    {
      key: '3',
      title: t('requestInfo:RiskCessationDate'),
      name: 'riskCessDate'
    },
    {
      key: '4',
      title: t('requestInfo:SumAssured'),
      name: 'sumAssured'
    },
    {
      key: '5',
      title: t('requestInfo:InstallmentPremium'),
      name: 'installmentPremium'
    }
  ]
  const reasonName = React.useMemo(() => {
    return pipe(
      CancelFromInceptionConst.reasons.find((x) => x.value === reason),
      O.fromNullable,
      O.fold(
        () => '',
        (reasonItem) => reasonItem.label
      )
    )
  }, [reason])

  const getRiderName = (riderCode: string) => {
    const item = riderNameList.find((x) => x.code === riderCode)
    return !!item ? riderCode + ' - ' + (i18n.language === 'en' ? item.name : item.nameVi) : ''
  }

  const cashlessMethod = methods.find(
    (x) => Object.values(PayoutPopup.CashlessMethod).findIndex((y) => y == x.method) >= 0
  )?.method

  const payoutData = {
    payPremium: methods.findIndex((x) => PayoutChecker(PayoutPopup.PayoutMethods.PAYPREMIUM)(x.method)) >= 0,
    repayLoan: methods.findIndex((x) => PayoutChecker(PayoutPopup.PayoutMethods.PAYLOAN)(x.method)) >= 0,
    otherPremium: methods.findIndex((x) => PayoutChecker(PayoutPopup.PayoutMethods.OTHER)(x.method)) >= 0,
    cashless: !!cashlessMethod,
    cashlessMethod: cashlessMethod as PayoutPopup.CashlessMethod,
    totalPayoutAmount: formatNumberWithComma(totalPayoutAmount),
    payouts: methods.map((x) => ({
      payoutMethod: x.method,
      detail: x.detail,
      amount: PulseOpsFormat.thousandSepartor(x.amount),
      status: x.status,
      note: x.note || '-'
    }))
  }


  const viewPayeeData = React.useMemo(() => {
    const viewData =
      cashOutList && cashOutList.length > 0
        ? getPayeeNotPOData(cashOutList as TaskDetailApi.PaymentData.CashOutList, branchName ?? '')
        : undefined
    return viewData
  }, [cashOutList])
  return (
    <View>
      <Title title={t('CancelRiderFromInception:RIDERLIST')} />
      {lifeAssureds.length > 0 &&
        lifeAssureds.map((lifeAssuredItem, index) => (
          <Panel title={lifeAssuredItem.clientName.toUpperCase()} key={index}>
            <TableField columns={columns} dataSource={lifeAssuredItem.submissionRiders.map((x) => ({ ...x, productionName: getRiderName(x.productCode) }))} />
          </Panel>
        ))}
      <Title title={t('CancelRiderFromInception:CANCELRIDERFROMINCEPTIONINFO')} />
      <SectionContent>
        <SectionRow>
          <SectionCol>
            <FieldText text={t('CancelRiderFromInception:RiderRefundAmount')}></FieldText>
            <FieldDescription text={formatNumberWithComma(riderRefundAmount)} isCurrencyUnit></FieldDescription>
          </SectionCol>
          {/* <SectionCol>
            <FieldText text={t('CancelRiderFromInception:SuspensePremium')}></FieldText>
            <FieldDescription text={formatNumberWithComma(suspensePremium)} isCurrencyUnit></FieldDescription>
          </SectionCol> */}
          <SectionCol>
            <FieldText text={t('Payout:TempRefundFee')}></FieldText>
            <FieldDescription text={formatNumberWithComma(refundableFeeAmount)} isCurrencyUnit></FieldDescription>
          </SectionCol>
        </SectionRow>
        <SectionRow sectionStyles={sharedStyle.secondLine}>
          <SectionCol>
            <FieldText text={t('CancelRiderFromInception:NetAmountAvailable')}></FieldText>
            <FieldDescription text={formatNumberWithComma(netAmountAvailable)} fieldStyles={sharedStyle.redText} isCurrencyUnit></FieldDescription>
          </SectionCol>
          <SectionCol>
            <FieldText text={t('CFI:Reason')}></FieldText>
            <FieldDescription text={reasonName}></FieldDescription>
          </SectionCol>
        </SectionRow>
      </SectionContent>
      <SectionRow sectionStyles={sharedStyle.secondLine}>
        <SectionCol sectionStyles={sharedStyle.col_12}>
          <PayoutMethod payeeData={viewPayeeData} payoutMethodData={payoutData}></PayoutMethod>
        </SectionCol>
      </SectionRow>
    </View>
  )
}